<template>
    <div style="background-color: #fff; width: 100vw">
        <navbar back_path="/search" :navbar_sub_visible="$device != 'mobile'" />
        <div>
            <center>
                <img
                    :src="image_url"
                    :style="{
                        width: $device == 'mobile' ? '100%' : '50%',
                    }"
                />
            </center>
            <div style="display: flex">
                <label class="title">
                    {{ title }}
                </label>
                <div class="star-box">
                    <img :src="`/resources/images/icon-star${favorite ? '-select' : ''}.png`" class="star" />
                </div>
            </div>
            <div style="width: 100%; padding: 16px">
                <div style="margin: 16px 0 0 0; background-color: #f5f5f5; border-left: 2px solid red; padding: 12px; color: #000">
                    <span style="font-size: 20px; font-weight: 600; word-break: break-all">
                        {{ detail }}
                    </span>
                </div>
            </div>
            <label class="description" v-html="description"> </label>
            <div style="text-align: center; width: 100%; padding: 16px; margin: 16px 0 0 0">
                <div style="width: 100%; background-color: #bebebe; border-radius: 8px; padding: 2px">
                    <div
                        :style="{
                            width: '50%',
                            'background-color': step == 'เงื่อนไขการใช้งาน' ? '#fff' : 'transparent',
                            'border-radius': '8px',
                            display: 'inline-block',
                        }"
                        @click="step = 'เงื่อนไขการใช้งาน'"
                    >
                        <label style="font-size: 16px; font-weight: 600; margin: 0"> เงื่อนไขการใช้งาน </label>
                    </div>
                    <div
                        :style="{
                            width: '50%',
                            'background-color': step == 'สาขาที่ร่วมรายการ' ? '#fff' : 'transparent',
                            'border-radius': '8px',
                            display: 'inline-block',
                        }"
                        @click="step = 'สาขาที่ร่วมรายการ'"
                    >
                        <label style="font-size: 16px; font-weight: 600; margin: 0"> สาขาที่ร่วมรายการ </label>
                    </div>
                </div>
            </div>
            <div v-if="step == 'เงื่อนไขการใช้งาน'">
                <label class="description" v-html="condition" />
            </div>
            <div v-else>
                <label class="description" v-html="branch" />
            </div>
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </div>
</template>
<script>
import navbar from '../../components/navbar';
export default {
    components: {
        navbar,
    },
    data: function () {
        return {
            ...this.$route.query.data,
            step: 'เงื่อนไขการใช้งาน',
        };
    },
    methods: {},
};
</script>
<style scoped>
.title {
    font-size: 20px;
    font-weight: 600;
    margin: 8px 40px 0 16px;
    color: #cc0000 !important;
    line-height: 32px;
}
.star-box {
    line-height: 50px;
    position: absolute;
    right: 0;
}
.star {
    width: 20px;
    height: 20px;
    margin: auto 0;
    margin-right: 10px;
}
.description {
    font-size: 16px;
    font-weight: 300;
    margin: 0 16px;
    color: #000 !important;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}
@media (max-device-width: 413px) {
    .title {
        font-size: 19px;
    }
    .description {
        font-size: 15px;
    }
}
@media (max-device-width: 374px) {
    .title {
        font-size: 17px;
    }
    .description {
        font-size: 13px;
    }
}
</style>
